import jQuery from "jquery";
import {ZIDXFormConfig} from "../../form/FormConfig.js";
import {ZIDXFormHelper} from "../../form/FormHelper.js";
import {ZIDXFormField} from "../../form/FormField.js";
import {ZIDXFormFieldType} from "../../form/FormFieldType.js";
import {ZIDXFormFieldValue} from "../../form/FormFieldValue.js";
import { ZIDX } from "../standaloneLibrary.js";

const $ = jQuery.noConflict();

export class ZIDXSavedSearchForm {
    // Do we really need this?
    // add the data fields for the form here:
    email:string="";

    // this allows array access
    [key:string]:any;

    json: string = "";

    // dialogContainer:HTMLDivElement;
    formElement:HTMLFormElement|null=null;
    lastDialogFormData:any={};
    // formDialog:JQuery;
    errorMessageId: string = "ZIDXErrorMessage";
    saved_search_id:string="";
    saved_search_key:string="";
    ai_chat_session_id:string="";

    zidx:ZIDX;
    constructor(zidx:ZIDX, id:string, key:string) {
        this.zidx = zidx;
        let self=this;
        this.saved_search_id=id;
        this.saved_search_key=key;
        this.ai_chat_session_id=this.extractUuidFromUrl(window.location.href);
        let width=0;
        let height=0;
        if($(window).width()!<992) {
            width=Math.min(600, $(window).width()! - 20);
            height=Math.min(550, $(window).height()!-20);
        }else{
            width=Math.min(600, $(window).width()!-50);
            height=Math.min(550, $(window).height()!-50);
        }
        // console.log("modal width:", width, "height:", height);
        // $("body").css({ overflow: 'hidden' });
        let formConfig=new ZIDXFormConfig();
        formConfig.action="/saved-search/fake"; // not used because we do ajax request below instead.
        formConfig.cancelURL="";
        formConfig.disableButtons=true;
        formConfig.formFields=[];

        self.getFormConfig(formConfig);
        let formHelper=new ZIDXFormHelper(this.zidx);
        let extraData={
            // useful if we need to pass more data
            "saved_search_format": 1,
            "saved_search_frequency": 1,
        };
        let formHtml = formHelper.getForm(formConfig, self, extraData);

        let modalContent1=`<div id="zidxSiteHomeSavedSearch" style="width:100%; float:left; padding:10px; border-radius:10px; background-color:var(--background-color); color:var(--text-color);"><div class="zidxBodyNoHeaderFooter"><div><h2 style="margin-top:0px;">Save Search</h2><p>Save this search to receive email notifications when new listings match your search.</p></div><div style="display: none;"><b>Please correct these items and try again.</b><br><p id="${self.errorMessageId}"></p></div>${formHtml}</div></div>`;
        // console.log("save modal:", modalContent1);
        //'<iframe src="'+url+'ztv='+Math.random()+'" scrolling="yes" frameborder="0"  style=" margin:0px; border:none; overflow:auto; -webkit-overflow-scrolling: touch; position:relative; " seamless="seamless" width="100%" height="98%" />';
        // @ts-ignore
        self.zidx.modalWindow.showModal(modalContent1,{
            'width':width,
            'height':height,
            "maxWidth":width,
            "maxHeight":height,
            "padding":0,
            "disableClose":false,
            "fullscreen":false
        });
        self.formElement=<HTMLFormElement>self.zidx.peakidxShadowRoot.getElementById(formHelper.formId)!;
        // console.log("form in modal", self.formElement);
        self.lastDialogFormData=self.zidx.getFormDataByFormId(self.formElement.id);
        // location.hash = "zidxDialogOpen";
        this.zidx.zidxBase.setFieldFromLocalStorage("#zidxSiteHomeSavedSearch", "email", "saved_search_email");

        // console.log("formElement:", self.formElement);
        $(".cancelSaveSearchModal", self.zidx.peakidxShadowRoot).on("click", function (event:JQuery.ClickEvent) {
           self.zidx.modalWindow.closeModal();
        });
        const formElement=self.zidx.peakidxShadowRoot.getElementById(formHelper.formId);
        formElement?.setAttribute("data-event-bound", "1");
        formElement?.addEventListener("submit", function (event:Event) {
            event.preventDefault();
            self.lastDialogFormData=self.zidx.getFormDataByFormId((self.formElement!).id);
            let data = self.zidx.getFormDataByFormId((self.formElement!).id);
            self.saveForm(data);
        });
    }

    getFormConfig(formConfig:ZIDXFormConfig){
        // console.log("displayForm row:", this);
        let field=new ZIDXFormField();
        field.name="saved_search_email";
        field.label="Email";
        field.required = true;
        field.type=ZIDXFormFieldType.EMAIL;
        formConfig.formFields.push(field);

        field = new ZIDXFormField();
        field.label = "Format";
        field.name="saved_search_format";
        field.type = ZIDXFormFieldType.RADIO;
        field.required = false;
        field.values = [
            new ZIDXFormFieldValue("HTML Text w/Photos", "1"),
            new ZIDXFormFieldValue("Plain Text", "2"),
        ]
        formConfig.formFields.push(field);


        field = new ZIDXFormField();
        field.label = "Frequency";
        field.name="saved_search_frequency";
        field.type = ZIDXFormFieldType.RADIO;
        field.required = false;
        field.values = [
            new ZIDXFormFieldValue("Every Day ", "1"),
            new ZIDXFormFieldValue("Every Week", "2"),
        ]
        formConfig.formFields.push(field);


        field=new ZIDXFormField();
        field.label="";
        field.name="anything";
        field.type=ZIDXFormFieldType.CUSTOM;
        field.custom=
            "<input type=\"hidden\" name=\"saved_search_id\" value=\""+this.saved_search_id+"\" />" +
            "<input type=\"hidden\" name=\"saved_search_key\" value=\""+this.saved_search_key+"\" />" +
            "<input type=\"hidden\" name=\"ai_chat_session_id\" value=\""+this.ai_chat_session_id+"\" />" +
            "<input type=\"submit\" class=\"zidxButton\" name=\"submit1\" value=\"Submit\"> <input type=\"button\" name=\"cancel1\" class=\"zidxButton cancelSaveSearchModal\" value=\"Cancel\"> ";
        formConfig.formFields.push(field);
    }
    extractUuidFromUrl(urlString: string): string {
        try {
            const url = new URL(urlString);

            // Regular expression to match /ai-search/ followed by a UUID v4
            const match = url.pathname.match(/\/ai-search\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i);

            return match ? match[1] : '';
        } catch (error) {
            // Returns an empty string if the provided string is not a valid URL
            return '';
        }
    }
    saveForm(data:any){
        let self=this;
        // I don't see any usage of this
        // update class fields
        for(var field in data){
            if(this.hasOwnProperty(field)){
                if(typeof this[field]=="number"){
                    this[field]=parseFloat(data[field]);
                }else if(typeof this[field]=="boolean"){
                    this[field] = data[field] == "1";
                }else if(typeof this[field]=="string"){
                    this[field]=data[field];
                }
            }
        }
        // to help debug form data changes
        data["saved_search_json_criteria"] = this.json;

        // console.log("saved search data:", data);
        // makes ajax call to java controller SavedSearchSaveController /save-search/
        let obj = {
            id: "ajaxSaveSearch",
            method: "post",
            postObj: data,
            ignoreOldRequests: false,
            callback: function(r:string){
                let js=JSON.parse(r);
                console.log("save search response:", js);
                if(js.success){
                    let savedSearches:any=localStorage.getItem("zidx.savedSearches");
                    if(savedSearches==null){
                        savedSearches={};
                    }else{
                        savedSearches=JSON.parse(savedSearches);
                    }
                    let data=JSON.parse(js.data);
                    data.saved_search_email=$("#zidxSiteHomeSavedSearch #saved_search_email", self.zidx.peakidxShadowRoot).val();
                    savedSearches[data.saved_search_id]=data;
                    localStorage.setItem("zidx.savedSearches", JSON.stringify(savedSearches));
                    localStorage.setItem("zidx.email", data.saved_search_email);
                    self.zidx.modalWindow.closeModal();
                }else{
                    self.showError(js.errorMessage);
                }
            },
            errorCallback: function(r:string){
                self.showError(r);
            },
            url: this.zidx.options.siteDomain + "/save-search/"
        };
        this.zidx.ajaxRequest(obj);

    }

    showError(message: string) {
        $(`#${this.errorMessageId}`, this.zidx.peakidxShadowRoot)
            .text(message)
            .parent().show();
    }
}